import { html, repeat, sync } from '@genesislcap/web-core';
import { getBidsGridColumns, getBidAuditHistoryColumns, PLATFORM_ACTIVITY_GRID_COLUMNS } from '../../../../mbm/utils/column-config';
import { clearFilterIcon, filterIcon } from '../../../../mbm/components/icons';
import type { PlatformActivityRoute } from './platform-activity';
import {customEvent} from '@genesislcap/foundation-events';
import {ColDef} from '@ag-grid-community/core';

export const PlatformActivityTemplate = html<PlatformActivityRoute>`
  <div class="platform-activity-main-container">
    <!-- Municipal Bonds Grid -->
    <div class="municipal-bonds-section">
      <div class="municipal-bonds-header">
        <h3>Municipal Bonds with Bids</h3>
        <div class="filters-container">
          <rapid-label class="filter-label">Filters:</rapid-label>
          <div class="cusip-filter">
            <rapid-text-field
              placeholder="CUSIP..."
              :value=${sync((x) => x.cusipFilterValue)}
              @input=${(x, c) => x.handleCusipInputChange(c.event)}
              @keyup=${(x, c) => x.handleCusipKeyUp(c.event)}
            ></rapid-text-field>
          </div>
          <div class="reference-filter">
            <rapid-text-field
              placeholder="Reference #..."
              :value=${sync((x) => x.referenceFilterValue)}
              @input=${(x, c) => x.handleReferenceInputChange(c.event)}
              @keyup=${(x, c) => x.handleReferenceKeyUp(c.event)}
            ></rapid-text-field>
          </div>
          <div class="issuer-filter">
            <rapid-text-field
              placeholder="Issuer..."
              :value=${sync((x) => x.issuerFilterValue)}
              @input=${(x, c) => x.handleIssuerInputChange(c.event)}
              @keyup=${(x, c) => x.handleIssuerKeyUp(c.event)}
            ></rapid-text-field>
          </div>
          <div class="counterparty-filter">
            <rapid-text-field
              placeholder="Counterparty..."
              :value=${sync((x) => x.counterpartyFilterValue)}
              @input=${(x, ctx) => x.handleCounterpartyInputChange(customEvent(ctx))}
              @keyup=${(x, ctx) => x.handleCounterpartyKeyUp(ctx.event as KeyboardEvent)}
            ></rapid-text-field>
          </div>
          <div class="filter-buttons">
            <rapid-button
              appearance="outline"
              @click=${(x) => x.handleFilterApply()}
            >
              <span slot="start" style="display: inline-flex; align-items: center; margin-right: 8px;">
                ${filterIcon}
              </span>
              Filter
            </rapid-button>
            <rapid-button
              appearance="outline"
              @click=${(x) => x.handleClearFilters()}
            >
              <span slot="start" style="display: inline-flex; align-items: center; margin-right: 8px;">
                ${clearFilterIcon}
              </span>
              Clear
            </rapid-button>
          </div>
        </div>
      </div>
      <mbm-grid-pro
        with-status-bar
        persist-column-state-key="platform-activity-municipal-bonds-grid-state"
        enable-row-flashing
        enable-cell-flashing
        only-template-col-defs
      >
        ${repeat(
            () => PLATFORM_ACTIVITY_GRID_COLUMNS,
            html<ColDef>`
            <grid-pro-column :definition="${(x) => x}"></grid-pro-column>
            `,
        )}
        <grid-pro-genesis-datasource
          resource-name="BONDS_WITH_ACTIVE_BIDS"
          :deferredGridOptions=${(x) => x.bondsGridOptions}
          criteria=${sync((x) => x.bondsFilterCriteria)}
          max-rows="1000"
          max-view="15000"
        ></grid-pro-genesis-datasource>
      </mbm-grid-pro>
    </div>

    <!-- Bids Grid -->
    <div style="display: flex; flex-direction: row; gap: 20px;height: 50%;">
      <div class="bids-section">
        <div class="bids-header">
          <h3>All Client Bids [${(x) => x.selectedBondCusip}]</h3>
        </div>
        <mbm-grid-pro
          with-status-bar
          persist-column-state-key="platform-activity-bids-grid-state"
          enable-row-flashing
          enable-cell-flashing
          only-template-col-defs
        >
          ${repeat(
              () => getBidsGridColumns(),
              html<ColDef>`
              <grid-pro-column :definition="${(x) => x}"></grid-pro-column>
              `,
          )}
          <grid-pro-genesis-datasource
            resource-name="ALL_BOND_BID_ACTIVITY"
            :deferredGridOptions=${(x) => x.bidsGridOptions}
            criteria=${sync((x) => x.bidsFilterCriteria)}
            max-rows="250"
            max-view="250"
          ></grid-pro-genesis-datasource>
        </mbm-grid-pro>
      </div>
      <div class="bids-section">
        <!-- Bid Audit History Grid -->
        <div class="bid-audit-history-header">
          <h3>Bid Audit History [${(x) => x.selectedBondCusip}]</h3>
        </div>
        <mbm-grid-pro
          with-status-bar
          persist-column-state-key="platform-activity-bid-audit-history-grid-state"
          enable-row-flashing
          enable-cell-flashing
          only-template-col-defs
        >
          ${repeat(
              () => getBidAuditHistoryColumns(),
              html<ColDef>`
              <grid-pro-column :definition="${(x) => x}"></grid-pro-column>
              `,
          )}
          <grid-pro-genesis-datasource
            resource-name="BOND_BID_AUDIT_HISTORY"
            :deferredGridOptions=${(x) => x.bidAuditHistoryGridOptions}
            criteria=${sync((x) => x.bidAuditHistoryFilterCriteria)}
            max-rows="500"
            max-view="500"
          ></grid-pro-genesis-datasource>
        </mbm-grid-pro>
      </div>
    </div>
  </div>
`;
